<template>
  <input :value="modelValue"
         @input="emit('update:modelValue', $event.target.value)"
         class="bg-gray-100 hover:bg-gray-200 rounded-lg inline-flex p-3 md:flex md:justify-between xl:max-w-sm text-sm font-medium text-gray-700" :type="type"
         :class="{
           ' w-full lg:max-w-sm': !inline,
           'ml-1.5': inline,
         }"
         :placeholder="placeholder"
         :autocomplete="autoComplete"
  >
</template>

<script setup>
const props = defineProps({
  type: {
    type: String,
    default: 'text',
  },
  modelValue: {
    type: String,
    default: '',
  },
  inline: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: ''
  },
  autoComplete: {
      type: String,
      default: 'off'
  }
})
const emit = defineEmits(['update:modelValue'])
</script>
